import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
const services = [{
  image: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-16-at-18.57.29.jpeg?v=23qed071g6l",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/maciej-karon-T719hFjv3mc-unsplash-scaled.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/maciej-karon-T719hFjv3mc-unsplash-scaled.png",
  alt: "Planting and turfing services Glasgow — lush lawn and border planting",
  title: "Lawnmower Servicing\n",
  description: "Annual services, blade sharpening, carburetor cleans, oil changes and full tune-ups for petrol and electric mowers of all makes.\n\n"
}, {
  image: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-16-at-18.42.54.jpeg?v=xqgwdryliu",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/zac-gudakov-CQkBjIfJjwY-unsplash-1-scaled.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/zac-gudakov-CQkBjIfJjwY-unsplash-1-scaled.png",
  alt: "Stonemasonry Glasgow — handcrafted stone walls and raised beds",
  title: "Ride-On Mower Repairs",
  description: "Deck repairs, belt replacements, engine overhauls and electrical fault-finding on ride-on and zero-turn mowers."
}, {
  image: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/8d689181-7956-45f7-b281-a1db41cc2b40.png?v=7nxw8vars9u",
  srcset: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/8d689181-7956-45f7-b281-a1db41cc2b40.png?v=7mxhmuzynr8",
  sizes: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/8d689181-7956-45f7-b281-a1db41cc2b40.png?v=gfgdjh5ladw",
  alt: "Timber fencing Glasgow — close-board fence and gate installation",
  title: "Strimmer Repair",
  description: "Recoil starter repairs, fuel line replacements, carb rebuilds and head servicing for petrol and battery-powered strimmers.\n\n"
}, {
  image: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-16-at-18.43.21.jpeg?v=eprs7l3nk9",
  srcset: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/6ea51f68-fc93-4704-b1a0-47e4bb6ed00c.png?v=e1w9ao8ijt4",
  sizes: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/6ea51f68-fc93-4704-b1a0-47e4bb6ed00c.png?v=34mr2bnuoa6",
  alt: "Garden design Glasgow — professionally designed outdoor space",
  title: "Chainsaw Servicing\n",
  description: "Chain sharpening and replacement, bar servicing, sprocket wear checks and full safety inspections for domestic and professional saws.\n\n"
}, {
  image: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/6ea51f68-fc93-4704-b1a0-47e4bb6ed00c.png?v=9ldp42kedub",
  srcset: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/6ea51f68-fc93-4704-b1a0-47e4bb6ed00c.png?v=a3shyjln",
  sizes: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/6ea51f68-fc93-4704-b1a0-47e4bb6ed00c.png?v=5lpktvcb6md",
  alt: "Patio installation Glasgow — natural stone and porcelain paving",
  title: "Hedge Trimmer",
  description: "Blade replacements, motor checks and full service on hedge trimmers, leaf blowers and vacuums across all brands.\n\n"
}, {
  image: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-16-at-18.45.17.jpeg?v=nl0nq4jmib",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/rakhmat-suwandi-wDC-SOW6AcM-unsplash-scaled.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/rakhmat-suwandi-wDC-SOW6AcM-unsplash-scaled.png",
  alt: "Driveways Glasgow — block paving and gravel driveway installation",
  title: "Construction Machinery\xA0",
  description: "Rotavators, cultivators, pressure washers and more. If it's powered and used in the garden, we can likely fix it.\n\n"
}, {
  image: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/0c52fb0f-f9b6-4fae-b13f-f2e1e2281632.png?v=z3rgyj996c",
  srcset: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/0c52fb0f-f9b6-4fae-b13f-f2e1e2281632.png?v=wuvilvamn19-wvc-srcset",
  sizes: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/0c52fb0f-f9b6-4fae-b13f-f2e1e2281632.png?v=y80sp4363yk-wvc-sizes",
  alt: "Professional leaf blower repair and maintenance service",
  title: "Blower Repairs",
  description: "Full service and part replacement for leaf blowers, backpack blowers, and handheld models."
}, {
  image: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-18-at-16.13.48.jpeg?v=0mpgdv7pizli",
  srcset: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-18-at-16.13.48.jpeg?v=fm8pu6yqgz-wvc-srcset",
  sizes: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-18-at-16.13.48.jpeg?v=m1ss5kslnbb-wvc-sizes",
  alt: "Repair and maintenance for garden construction equipment",
  title: "Nail\xA0 Gun Repairs",
  description: "Repair and maintenance for nail guns, brad nailers, finish nailers, framing nailers, and other pneumatic and cordless fastening tools."
}, {
  image: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/716961e8-67f1-4cea-aa57-65e4dc2ad3df.png?v=53e0z87gmln",
  srcset: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/716961e8-67f1-4cea-aa57-65e4dc2ad3df.png?v=aolxwgpa6jm-wvc-srcset",
  sizes: "https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/716961e8-67f1-4cea-aa57-65e4dc2ad3df.png?v=h7zrh08st7a-wvc-sizes",
  alt: "Brushcutter repair service",
  title: "Brushcutter Repair",
  description: "Full service and part replacement for brushcutters, including blade sharpening, engine tuning, and battery maintenance."
}];
export default function ServicesGrid() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);
  return;
}